import React from 'react';
import { Icon, IconButton } from '@chakra-ui/react';
import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { ff } from '../../../theme';

type Props = {
  /** Explicit destination; uses browser back when omitted. */
  to?: string;
  /** Replace the current history entry instead of pushing (avoids back-button loops). */
  replace?: boolean;
  /** Kept for existing callers; both variants render the board's 44px chevron. */
  variant?: 'v2' | 'plain';
  'aria-label'?: string;
};

const BountyBackButton: React.FC<Props> = ({ to, replace = false, 'aria-label': ariaLabel = 'Back' }) => {
  const navigate = useNavigate();
  const goBack = () => (to ? navigate(to, { replace }) : navigate(-1));

  return (
    <IconButton
      aria-label={ariaLabel}
      icon={<Icon as={FiChevronLeft} boxSize="22px" strokeWidth={2.4} />}
      variant="ghost"
      alignSelf="flex-start"
      flex="none"
      minW="44px"
      w="44px"
      h="44px"
      borderRadius="full"
      color={ff.ink}
      _hover={{ bg: ff.grey }}
      _active={{ bg: ff.grey }}
      onClick={goBack}
    />
  );
};

export default BountyBackButton;
